<div fxLayout="row" fxLayoutAlign="space-between center">
  <h2 class="row">{{ "sdt-position.title" | translate }}</h2>
  <div *ngIf="topMenuIcons.length > 0">
    <button mat-raised-button [disabled]="
          !this.detailForm.valid" (click)="save()">
      <mat-icon [title]="this.saveIconTitle"> save </mat-icon>
    </button>
    <button mat-raised-button *ngIf="!this.copy" [disabled]="this.disableByProfile" (click)="copyItem()">
      <mat-icon [title]="this.copyIconTitle"> content_copy </mat-icon>
    </button>
    <button mat-raised-button *ngIf="this.id !== 'new'" (click)="deleteConfirm()">
      <mat-icon [title]="this.deleteIconTitle"> delete </mat-icon>
    </button>
    <ng-container *ngFor="let action of topMenuIcons">
      <button mat-raised-button *ngIf="!action.hide" [routerLink]="action.routerLink"
        (click)="this[action.clickMethod]()">
        <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
      </button>
    </ng-container>
  </div>
</div>
<form [formGroup]="detailForm">
  <div fxLayout="column">
    <div fxLayout="row wrap" fxLayoutGap="40px">
      <mat-form-field *ngIf="columnsVisible.get('id')" [ngStyle]="{
            'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
            'min-width.px': 300
          }">
        <mat-label> {{ "sdt-position.id" | translate }} </mat-label>
        <input matInput [ngStyle]="{
              'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
              'min-width.px': 300
            }" formControlName="id" />
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('name')" [ngStyle]="{
            'width.ch': detailForm.controls['name'].value ? detailForm.controls['name'].value.length : 10,
            'min-width.px': 300
          }">
        <mat-label>{{ "sdt-position.name" | translate }}</mat-label>
        <input matInput class="form-control" [ngStyle]="{
              'width.ch': detailForm.controls['name'].value ? detailForm.controls['name'].value.length : 10,
              'min-width.px': 300
            }" formControlName="name" />
        <mat-error *ngIf="detailForm.controls['name'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('chainage')" [ngStyle]="{
            'width.ch': detailForm.controls['chainage'].value ? detailForm.controls['chainage'].value.length : 10,
            'min-width.px': 200
          }">
        <mat-label>{{ "sdt-position.chainage" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
              'width.ch': detailForm.controls['chainage'].value ? detailForm.controls['chainage'].value.length : 10,
              'min-width.px': 180
            }" formControlName="chainage" [step]="countDecimalPlaces(detailForm.controls['chainage'].value)" />
        <mat-error *ngIf="detailForm.controls['chainage'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['chainage'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>


      <mat-form-field *ngIf="columnsVisible.get('actInclination')" [ngStyle]="{
        'width.ch': detailForm.controls['actInclination'].value ? detailForm.controls['actInclination'].value.length : 10,
        'min-width.px': 200
      }">
        <mat-label>{{ "sdt-position.act-inclination" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
          'width.ch': detailForm.controls['actInclination'].value ? detailForm.controls['actInclination'].value.length : 10,
          'min-width.px': 180
        }" formControlName="actInclination" [step]="countDecimalPlaces(detailForm.controls['actInclination'].value)" />
        <mat-error *ngIf="detailForm.controls['actInclination'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['actInclination'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('planInclination')" [ngStyle]="{
    'width.ch': detailForm.controls['planInclination'].value ? detailForm.controls['planInclination'].value.length : 10,
    'min-width.px': 200
  }">
        <mat-label>{{ "sdt-position.plan-inclination" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
      'width.ch': detailForm.controls['planInclination'].value ? detailForm.controls['planInclination'].value.length : 10,
      'min-width.px': 180
    }" formControlName="planInclination" [step]="countDecimalPlaces(detailForm.controls['planInclination'].value)" />
        <mat-error *ngIf="detailForm.controls['planInclination'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['planInclination'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('prevInclination')" [ngStyle]="{
    'width.ch': detailForm.controls['prevInclination'].value ? detailForm.controls['prevInclination'].value.length : 10,
    'min-width.px': 200
  }">
        <mat-label>{{ "sdt-position.prev-inclination" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
      'width.ch': detailForm.controls['prevInclination'].value ? detailForm.controls['prevInclination'].value.length : 10,
      'min-width.px': 180
    }" formControlName="prevInclination" [step]="countDecimalPlaces(detailForm.controls['prevInclination'].value)" />
        <mat-error *ngIf="detailForm.controls['prevInclination'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['prevInclination'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="40px">
      <mat-checkbox *ngIf="this.id !== 'new' && columnsVisible.get('directionGermany')" matInput [ngStyle]="{
                                'width.ch': 10,
                                  'min-width.px': 120

                              }" formControlName="directionGermany">{{ "sdt-position.direction-germany" | translate
        }}</mat-checkbox>

      <mat-form-field *ngIf="columnsVisible.get('hightFirstBerm')" [ngStyle]="{
                'width.ch': detailForm.controls['hightFirstBerm'].value ? detailForm.controls['hightFirstBerm'].value.length : 10,
                'min-width.px': 200
              }">
        <mat-label>{{ "sdt-position.hight-first-berm" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                  'width.ch': detailForm.controls['hightFirstBerm'].value ? detailForm.controls['hightFirstBerm'].value.length : 10,
                  'min-width.px': 180
                }" formControlName="hightFirstBerm"
          [step]="countDecimalPlaces(detailForm.controls['hightFirstBerm'].value)" />
        <mat-error *ngIf="detailForm.controls['hightFirstBerm'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['hightFirstBerm'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('diffBermHeight')" [ngStyle]="{
                  'width.ch': detailForm.controls['diffBermHeight'].value ? detailForm.controls['diffBermHeight'].value.length : 10,
                  'min-width.px': 200
                }">
        <mat-label>{{ "sdt-position.diff-berm-height" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                    'width.ch': detailForm.controls['diffBermHeight'].value ? detailForm.controls['diffBermHeight'].value.length : 10,
                    'min-width.px': 180
                  }" formControlName="diffBermHeight"
          [step]="countDecimalPlaces(detailForm.controls['diffBermHeight'].value)" />
        <mat-error *ngIf="detailForm.controls['diffBermHeight'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['diffBermHeight'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('nrBerms')" [ngStyle]="{
                    'width.ch': detailForm.controls['nrBerms'].value ? detailForm.controls['nrBerms'].value.length : 10,
                    'min-width.px': 200
                  }">
        <mat-label>{{ "sdt-position.nr-berms" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                      'width.ch': detailForm.controls['nrBerms'].value ? detailForm.controls['nrBerms'].value.length : 10,
                      'min-width.px': 180
                    }" formControlName="nrBerms" [step]="countDecimalPlaces(detailForm.controls['nrBerms'].value)" />
        <mat-error *ngIf="detailForm.controls['nrBerms'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['nrBerms'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('actBermSpacing')" [ngStyle]="{
              'width.ch': detailForm.controls['actBermSpacing'].value ? detailForm.controls['actBermSpacing'].value.length : 10,
              'min-width.px': 200
            }">
        <mat-label>{{ "sdt-position.act-berm-spacing" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['actBermSpacing'].value ? detailForm.controls['actBermSpacing'].value.length : 10,
                'min-width.px': 180
              }" formControlName="actBermSpacing" [step]="countDecimalPlaces(detailForm.controls['actBermSpacing'].value)" />
        <mat-error *ngIf="detailForm.controls['actBermSpacing'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['actBermSpacing'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="columnsVisible.get('planBermSpacing')" [ngStyle]="{
              'width.ch': detailForm.controls['planBermSpacing'].value ? detailForm.controls['planBermSpacing'].value.length : 10,
              'min-width.px': 200
            }">
        <mat-label>{{ "sdt-position.plan-berm-spacing" | translate }}</mat-label>
        <input matInput type="number" class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['planBermSpacing'].value ? detailForm.controls['planBermSpacing'].value.length : 10,
                'min-width.px': 180
              }" formControlName="planBermSpacing" [step]="countDecimalPlaces(detailForm.controls['planBermSpacing'].value)" />
        <mat-error *ngIf="detailForm.controls['planBermSpacing'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['planBermSpacing'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-checkbox *ngIf="this.id !== 'new' && columnsVisible.get('autoCorrection')" matInput [ngStyle]="{
        'width.ch': 10,
          'min-width.px': 120

      }" formControlName="autoCorrection">{{ "sdt-position.auto_correction" | translate
      }}</mat-checkbox>

      <mat-checkbox *ngIf="this.id !== 'new' && columnsVisible.get('lock')" matInput [ngStyle]="{
        'width.ch': 10,
          'min-width.px': 120

      }" formControlName="lock">{{ "sdt-position.lock" | translate
      }}</mat-checkbox>

      <mat-form-field *ngIf="columnsVisible.get('latestError')" [ngStyle]="{
              'width.ch': detailForm.controls['latestError'].value ? detailForm.controls['latestError'].value.length : 10,
              'min-width.px': 300
            }">
        <mat-label>{{ "sdt-position.latest-error" | translate }}</mat-label>
        <input matInput class="form-control" [ngStyle]="{
                'width.ch': detailForm.controls['latestError'].value ? detailForm.controls['latestError'].value.length : 10,
                'min-width.px': 300
              }" formControlName="latestError" />
        <mat-error *ngIf="detailForm.controls['latestError'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
      </mat-form-field>


    </div>

  </div>

  <mat-accordion multi>

    <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "sdt-position.header-berm-tunnel" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-panel-description>
        <div fxLayout="row wrap" fxLayoutGap="40px">
          <div fxLayout="column">
            <mat-label>{{ "sdt-position.berm-height-target" | translate }}</mat-label>
            <ng-container *ngFor="let bermHeightTarget of this.bermHeightTargets; let idx = index">
              <app-list-input class="row" [items]="this.bermHeightTargets" [currentIndex]="idx"
                [value]="this.bermHeightTargets[idx]" [step]="countDecimalPlaces(this.bermHeightTargets[idx])" [disabled]="true"
                [editable]="false"></app-list-input>
            </ng-container>
          </div>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="40px">
          <div fxLayout="column">
            <mat-label>{{ "sdt-position.berm-spacing" | translate }}</mat-label>
            <ng-container *ngFor="let bermSpacing of this.bermSpacings; let idx = index">
              <app-list-input class="row" [items]="this.bermSpacings" [currentIndex]="idx"
                [value]="this.bermSpacings[idx]" [step]="countDecimalPlaces(this.bermSpacings[idx])" [disabled]="true"
                [editable]="false"></app-list-input>
            </ng-container>
          </div>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="40px">
          <div fxLayout="column">
            <mat-label>{{ "sdt-position.tunnel-depths" | translate }}</mat-label>
            <ng-container *ngFor="let tunnelDepth of this.tunnelDepths; let idx = index">
              <app-list-input class="row" [items]="this.tunnelDepths" [currentIndex]="idx"
                [value]="this.tunnelDepths[idx]" [step]="countDecimalPlaces(this.tunnelDepths[idx])" [disabled]="true"
                [editable]="false"></app-list-input>
            </ng-container>
          </div>
        </div>


      </mat-panel-description>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)" *ngIf="sdtOptimizers?.length > 0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "sdt-position.optimiser" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-panel-description>
        <table mat-table [dataSource]="sdtOptimizers" class="mat-elevation-z8">
          <!-- Berm Height Diff Column -->
          <ng-container matColumnDef="bermHeightDiff">
            <th mat-header-cell *matHeaderCellDef [style]="headerStyle">
              {{ "sdt-position-optimiser.berm-height-diff" | translate }}
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.bermHeightDiff }} </td>
          </ng-container>

          <!-- Max Prec Specs Column -->
          <ng-container matColumnDef="maxPrecSpecs">
            <th mat-header-cell *matHeaderCellDef  [style]="headerStyle">
              {{ "sdt-position-optimiser.max-prec-specs" | translate }}
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.maxPrecSpecs }} </td>
          </ng-container>

          <!-- Calc Status Column -->
          <ng-container matColumnDef="calcStatus">
            <th mat-header-cell *matHeaderCellDef  [style]="headerStyle">
              {{ "sdt-position-optimiser.calc-status" | translate }}
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.calcStatus }} </td>
          </ng-container>

          <!-- Last Error Column -->
          <ng-container matColumnDef="lastError">
            <th mat-header-cell *matHeaderCellDef  [style]="headerStyle">
              {{ "sdt-position-optimiser.last-error" | translate }}
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.lastError }} </td>
          </ng-container>

          <!-- Last Modification Date Column -->
          <ng-container matColumnDef="lastModificationDate">
            <th mat-header-cell *matHeaderCellDef  [style]="headerStyle">
              {{ "sdt-position-optimiser.last-modification-date" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.lastModificationDate ? (element.lastModificationDate | date:'yyyy-MM-dd HH:mm') : '' }}
            </td>
          </ng-container>

          <!-- Header and Row Declarations -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>



      </mat-panel-description>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true" *ngIf="this.id !== 'new'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'log-messages.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-panel-description>
        <app-log-messages-list [ngStyle]="{
          'width.pc': 100
        }" [modelId]="this.id"></app-log-messages-list>
      </mat-panel-description>
    </mat-expansion-panel>
  </mat-accordion>
</form>